<template>
  <div>
    <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
      <div class="uk-card-body">
        <div class="uk-overflow-auto">
          <table
            class="uk-table uk-table-middle uk-table-hover uk-table-divider"
            v-if="offers.length"
          >
            <thead>
              <tr>
                <th class="uk-table-expand">Name</th>
                <th class="uk-table-expand">Fahrzeug</th>
                <th class="uk-table-shrink uk-text-right">Datum</th>
                <th style="width:85px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="offer in offers" :key="offer.id">
                <td>
                  <span v-if="Object.keys(offer.data).length && offer.data.customer">
                    <template v-if="offer.data.customer.company">
                      {{ offer.data.customer.company }}
                    </template>
                    <template v-else>
                      {{ offer.data.customer.firstname }} {{ offer.data.customer.lastname }}
                    </template>
                  </span>
                </td>
                <td>
                  {{ offer.name }}<br /><span class="uk-text-small">Nr.: {{ offer.carId }}</span>
                </td>
                <td class="uk-text-right uk-text-nowrap">{{ offer.formatedDate }}</td>
                <td class="uk-text-right">
                  <a
                    href="#"
                    class="uk-text-primary"
                    :uk-icon="'icon: download'"
                    @click.prevent="getPdf(offer)"
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
          <!--
          <table class="uk-table uk-table-middle uk-table-divider" v-if="sales.length">
            <thead>
              <tr>
                <th class="uk-width-small">Datum</th>
                <th class="uk-width-small">Bestell-Nr.</th>
                <th>Fahrzeug</th>
                <th>Preis Netto</th>
                <th class="uk-width-small">Bestellung (PDF)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="sale in sales">
                <tr v-for="(item, key) in sale.items" :key="item.id">
                  <td v-if="key == 0">{{ sale.date }}</td>
                  <td v-else>&nbsp;</td>
                  <td v-if="key == 0">{{ sale.number }}</td>
                  <td v-else>&nbsp;</td>
                  <td>
                    {{ item.make }} {{ item.model }} {{ item.edition }}<br />
                    <span class="uk-text-small"> Nr.: {{ item.carId }} </span>
                  </td>
                  <td>{{ item.price }}</td>
                  <td>
                    <a
                      href="#"
                      class="uk-text-primary uk-align-right uk-margin-right"
                      :uk-icon="'icon: download'"
                      @click.prevent="getContractPdf(item.id)"
                      v-if="requestDownload !== item.id"
                    ></a>
                    <div uk-spinner v-if="requestDownload === item.id" class="uk-align-right"></div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          -->
        </div>
        <div v-if="!offers.length" class="uk-margin-remove uk-h4">
          Keine Angebote vorhanden!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Configuration from '@/configuration';
const baseURL = Configuration.value('apiBackend')
export default {
  props: {
    offers: {
      required: true
    }
  },
  data() {
    return {
      requestDownload: null
    }
  },
  methods: {
    getPdf(offer) {
      axios({
        url: `${baseURL}/offer/print/${offer.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${offer.filename}`)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
